<template>
  <div class="app-container">
    <transition-group name="el-zoom-in-center">
      <!-- 项目头部列表 -->
      <div v-show="showList" key="header" class="filter-container">
        <el-card shadow="never" style="margin-bottom: 20px;">
          <span style="padding:0 10px 0 20px;line-height:40px;font-size: 16px">我的余额：  {{ money }}元</span>
          <span style="padding:0 10px 0 20px;line-height:40px;font-size:16px">统计金额：  {{ totalMoney }}元</span>
          <el-button
            v-waves
            v-if="calcPermission(permition, 2)"
            round
            class="filter-item"
            type="primary"
            size="small"
            @click="handleCash"
          >{{ $t('table.destoonFinanceCash') }}</el-button>
          <el-button
            v-waves
            v-if="calcPermission(permition, 2)"
            round
            class="filter-item"
            type="primary"
            size="small"
            @click="handleBindingBank"
          >{{ ruleForm.BankNo?'编辑银行卡':'绑定银行卡' }}</el-button>
        </el-card>
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col :lg="3">
              <el-input v-model="listQuery.userName" class="filter-item" placeholder="请输入用户名" @change="handleInput"/>
            </el-col>
            <el-col :lg="3">
              <el-select v-model="listQuery.type" class="filter-item" style="width:100%" placeholder="请选择类型">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </el-col>
            <el-col :lg="3">
              <el-input v-model="listQuery.fieldName" class="filter-item" placeholder="请输入场地名称" @change="handleInput"/>
            </el-col>
            <el-col :lg="3">
              <el-input v-model="listQuery.identity" class="filter-item" placeholder="请输入设备编号" @change="handleInput"/>
            </el-col>
            <el-col :lg="3">
              <div class="filter-item">
                <el-date-picker
                  v-model="listQuery.startTime"
                  :clearable="false"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择开始日期"/>
              </div>

            </el-col>
            <el-col :lg="3">
              <div class="filter-item">
                <el-date-picker
                  v-model="listQuery.endTime"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="选择结束日期"/>
              </div>

            </el-col>
            <el-col :lg="2">
              <el-button
                v-waves
                v-if="calcPermission(permition, 1)"
                round
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
              >{{ $t('table.search') }}</el-button>
            </el-col>
            <el-col :lg="2">
              <el-button round type="primary" icon="el-icon-download" @click="handleDown">导出</el-button>
            </el-col>
          </el-row>
        </el-card>

      </div>
      <!-- 项目列表 -->
      <div v-show="showList" key="list" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"
          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.userName')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.type')" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.AccountDetail.Type"
              >{{ scope.row.AccountDetail.Type | filterType }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`收益(元)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AccountDetail.Rmb">{{ scope.row.AccountDetail.Rmb }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.memo')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AccountDetail.Memo">{{ scope.row.AccountDetail.Memo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column label="场地名称" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldName">{{ scope.row.FieldName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="设备编号" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Identity">{{ scope.row.Identity }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderNo">{{ scope.row.OrderNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="付款金额(元)" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.PayMoney">{{ scope.row.PayMoney }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="押金金额(元)" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Deposit">{{ scope.row.Deposit }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.OrderState"
              >{{ scope.row.OrderState === 'A' ? '进行中' : scope.row.OrderState === 'D' ? '使用中' : scope.row.OrderState === 'S' ? '订单结束' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`退款金额(元)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.RetCoinMoney">{{ scope.row.RetCoinMoney }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`退款状态`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.RetCoinStatus === 'SUCCESS' ? '退款成功' : (scope.row.RetCoinStatus === 'ERROR' ? '退款失败' : '') }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`箱号`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.BoxNo }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`存放人`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderUserName }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`存放手机号`" align="center">
            <template slot-scope="scope">
              <span v-if="parseInt(scope.row.TakeTel)">{{ scope.row.TakeTel }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>

          <el-table-column :label="`开始存放时间`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.StartTime }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <el-table-column :label="`结束存放时间`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.EndTime }}</span>
              <!-- <span v-else>0</span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.addUser')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AddUserId">{{ scope.row.AddUserId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>-->
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition-group>
    <!-- 申请提现弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      title="请选择提现方式"
      width="30%"
    >
      <el-row :gutter="20" type="flex" style="justify-content: center;margin-bottom: 20px;">
        <el-col :span="3.5">
          <h4 style="margin: 0;line-height: 35px;">提现方式
        </h4></el-col>
        <el-col :span="10">
          <el-select v-model="value" placeholder="请选择提现方式" @change="handleChangeType">
            <el-option
              v-for="item in withdrawType"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-col>
      </el-row>

      <el-card shadow="never">
        <div v-show="value === 'QRcode'" id="qrcode" ref="qrcode"/>
        <el-row v-show="value !== 'QRcode'" :gutter="20">
          <template v-if="ruleForm.BankNo">
            <el-col :span="24">
              <p>
                姓名： {{ ruleForm.TrueName }}({{ ruleForm.TelPhone }})
              </p>
            </el-col>
            <el-col :span="24">
              <p>
                银行卡号：{{ ruleForm.BankNo }}
              </p>
            </el-col>
            <el-col :span="24">
              <p>
                开户行：{{ ruleForm.BankType }}
              </p>
            </el-col>
            <el-col :span="24">
              <el-form ref="amountForm" :model="amountForm" :rules="rules" label-width="100px" class="demo-ruleForm">
                <el-form-item prop="returnCount" class="form-input" label-width="0">
                  <el-input v-model="amountForm.returnCount" class="amount" placeholder="请输入提现金额"/>
                </el-form-item>
                <el-form-item prop="vCode" class="form-input" label-width="0">
                  <el-row :gutter="10">
                    <el-col :span="10">
                      <el-input v-model="amountForm.vCode" :maxlength="6" class="amount" placeholder="请输入验证码"/>
                    </el-col>
                    <el-col :span="3">
                      <el-button :disabled="codeShow" type="primary" @click="getCode">{{ codeShow?codeTime:'获取验证码' }}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <p style="color: #F56C6C;">注：本次提现手续费费率为 {{ Poundage }}</p>
              </el-form>
            </el-col>
          </template>
          <template v-else>
            未绑定银行卡
          </template>
          <!-- style="margin-top: 20px;border: none; border-radius: 0;border-top: solid #999 1px;border-bottom: solid #999 1px;" -->

        </el-row>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelType">取 消</el-button>
        <el-button v-show="value === 'bankIc' && ruleForm.BankNo" type="primary" @click="handleConfirmType('amountForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定银行卡弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleBank"
      :before-close="handleClose"
      title="绑定银行卡"
      width="30%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="TrueName">
          <el-input v-model="ruleForm.TrueName" placeholder="请输入开户行姓名"/>
        </el-form-item>
        <el-form-item label="银行卡卡号" prop="BankNo">
          <el-input v-model="ruleForm.BankNo" placeholder="请输入银行卡卡号" />
        </el-form-item>
        <el-form-item label="开户行" prop="BankCode">
          <el-select v-model="ruleForm.BankCode" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { qryRoleInfo } from '@/api/baseModule'
import { qryAccountFlow, getBankInfo, updateBankInfo, applyReturnCoin, exportAccountFlowExcel, getBankApplyVaildateCode } from '@/api/account'
import { qryUserInfo } from '@/api/user'
import QrCode from 'qrcodejs2'
import waves from '@/directive/waves' // 水波纹指令
import moment from 'moment'
export default {
  directives: {
    waves
  },
  filters: {
    filterType(value) {
      let str = ''
      switch (value) {
        case 'profit':
          str = '收益'
          break
        case 'topUp':
          str = '充值'
          break
        case 'back':
          str = '退回'
          break
        case 'ext':
          str = '提现'
          break
        case 'consum':
          str = '消费'
          break
        case 'deduct':
          str = '扣除'
          break
      }
      return str
    }
  },
  data() {
    var validAmount = (rule, value, callback) => {
      if (/^\d?\.?\d+$/.test(value) && value <= this.money) {
        callback()
      } else {
        callback(new Error('只能输入整数或者小数并且小于我的余额，小数保留两位小数'))
      }
    }
    const validCode = (rule, value, callback) => {
      if (/^\d{4,6}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入验证码，只能输入数字'))
      }
    }
    return {
      codeShow: false,
      codeTime: 59,
      typeOptions: [
        {
          value: 'profit',
          label: '收益'
        },
        {
          value: 'back',
          label: '退回'
        },
        {
          value: 'topUp',
          label: '充值'
        },
        {
          value: 'ext',
          label: '提现'
        },
        {
          value: 'consum',
          label: '消费'
        },
        {
          value: 'deduct',
          label: '扣除'
        },
        {
          value: 'assign',
          label: '发放'
        }
      ],
      rules: {
        TrueName: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        BankNo: [
          { required: true, message: '请填写银行卡账号', trigger: 'blur' }
        ],
        BankCode: [
          { required: true, message: '请选择开户行', trigger: 'blur' }
        ],
        returnCount: [
          { required: true, message: '请填写提现金额', trigger: 'blur' },
          { validator: validAmount, trigger: 'blur' }
        ],
        vCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validCode, trigger: 'blur' }
        ]
      },
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        type: 'profit',
        identity: null,
        fieldName: null,
        loginNo: null,
        userName: null,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      },
      ruleForm: {
        TrueName: null,
        BankNo: null,
        UserId: null,
        BankType: null,
        BankCode: null
      },
      withdrawType: [
        {
          value: 'QRcode',
          label: '微信'
        },
        {
          value: 'bankIc',
          label: '银行卡'
        }
      ],
      amountForm: {
        returnCount: null,
        userId: null,
        type: 2,
        openId: null,
        vCode: null
      },
      options: [],
      list: null,
      showList: true,
      permition: 0,
      listLoading: true,
      tableKey: 0,
      dialogVisible: false,
      total: null,
      money: 0,
      totalMoney: 0,
      dialogVisibleBank: false,
      value: 'bankIc',
      BankNo: null,
      Poundage: 0,
      url_: process.env.BASE_API
    }
  },
  created() {
    this.amountForm.userId = this.ruleForm.UserId = this.$store.getters.roles.UserId
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryList()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryList()
          }
        })
      })
    }
    // 获取银行列表
    getBankInfo().then(res => {
      this.options = JSON.parse(res)
      this.options = this.options.map(item => {
        return {
          value: item[Object.keys(item)],
          label: Object.keys(item)[0]
        }
      })
    })
    // 查询用户是否绑定银行卡
    this.getBank()
  },
  methods: {
    // 查询列表
    qryList() {
      console.log(this.listQuery)
      qryAccountFlow(this.listQuery).then(response => {
        this.list = response.LsList.LsList
        this.total = response.LsList.TotalRows
        this.totalMoney = response.CurrentMoney
        this.money = response.TotalMoney
        this.listLoading = false
        // this.resetTemp()
      })
    },
    getCode() {
      this.codeShow = true
      const time = setInterval(() => {
        this.codeTime--
        if (this.codeTime < 1) {
          clearInterval(time)
          this.codeTime = 59
          this.codeShow = false
        }
      }, 1000)
      getBankApplyVaildateCode({ telPhone: this.ruleForm.TelPhone }).then(res => {
        this.$notify({
          type: 'success',
          title: '成功',
          message: '验证码发送成功'
        })
      }).catch(() => {
        clearInterval(time)
        this.codeTime = 59
        this.codeShow = false
      })
    },
    // 导出
    handleDown() {
      const { userName, fieldName, identity, type, startTime, endTime } = this.listQuery
      exportAccountFlowExcel({ userName, fieldName, identity, type, startTime, endTime }).then(res => {
        if (res) {
          window.open(this.url_ + res)
        }
      })
    },
    // 搜索完删除充值
    handleInput() {
      if (this.listQuery.userName === '') {
        this.listQuery.userName = null
      }
      if (this.listQuery.fieldName === '') {
        this.listQuery.fieldName = null
      }
      if (this.listQuery.identity === '') {
        this.listQuery.identity = null
      }
    },
    // 重置查询数据
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        type: 'profit',
        identity: null,
        fieldName: null,
        loginNo: null,
        userName: null,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      }
    },
    // 修改页容量重新查询列表
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.qryList()
    },
    // 修改页码重新查询列表
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.qryList()
    },
    // 申请提现
    handleCash() {
      this.dialogVisible = true
    },
    // 切换提现方式
    handleChangeType() {
      if (this.value === 'QRcode') {
        this.$nextTick(() => {
          console.log(111)
          if (!this.qr) {
            this.qr = new QrCode('qrcode', {
              text: process.env.BASE_API + '/asd/WithDraw.html?loginNo=' + this.$store.getters.roles.LogNo,
              width: 200,
              height: 200,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QrCode.CorrectLevel.H
            })
          } else {
            this.qr.makeCode(process.env.BASE_API + '/asd/WithDraw.html?loginNo=' + this.$store.getters.roles.LogNo)
          }
        })
      } else {
        // 查询用户是否绑定银行卡
        this.getBank()
      }
    },
    // 查询用户是否绑定银行卡
    getBank() {
      qryUserInfo({
        userId: this.$store.getters.roles.UserId
      }).then(res => {
        this.ruleForm.BankNo = res.LsList[0].BankNo
        this.ruleForm.BankCode = res.LsList[0].BankCode
        this.ruleForm.TrueName = res.LsList[0].TrueName
        this.ruleForm.BankType = res.LsList[0].BankType
        this.amountForm.openId = this.ruleForm.TelPhone = res.LsList[0].TelPhone
        this.Poundage = res.LsList[0].Poundage
      })
    },
    // 绑定银行卡按钮事件
    handleBindingBank() {
      this.dialogVisibleBank = true
      this.getBank()
    },
    // 确定绑定
    handleConfirm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          for (const iterator of this.options) {
            if (iterator.value === this.ruleForm.BankCode) {
              this.ruleForm.BankType = iterator.label
              break
            }
          }
          updateBankInfo(this.ruleForm).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.dialogVisibleBank = false
            }
          })
        }
      })
    },

    // 取消绑定
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.dialogVisibleBank = false
    },
    handleClose(done) {
      console.log(this.ruleForm)
      if (this.dialogVisibleBank) {
        console.log(11111)
        this.$refs['ruleForm'].resetFields()
      }
      if (this.dialogVisible) {
        console.log(222)
        if (this.ruleForm.BankNo) {
          this.$refs['amountForm'].resetFields()
        }
      }
      done()
    },
    // 确定提现
    handleConfirmType(amountForm) {
      this.$refs[amountForm].validate(valid => {
        if (valid) {
          applyReturnCoin(this.amountForm).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '提现成功'
              })
              this.dialogVisible = false
              this.money = this.money - this.amountForm.returnCount
              this.qryList()
            }
          })
        }
      })
    },
    // 取消提现
    handleCancelType() {
      if (this.ruleForm.BankNo) {
        this.$refs['amountForm'].resetFields()
      }
      this.dialogVisible = false
    },
    handleFilter() {
      this.qryList()
    }
  }
}
</script>

<style lang="less">
#qrcode {
  img {
    margin: 0 auto;
  }
}
.amount{
  .el-input__inner{
    border: none;
    border-radius: 0;
    background: #eee;
    color: #333;
    &::-webkit-input-placeholder{
      color: #333;
    }
    &:-moz-placeholder{
      color: #333;
    }
    &::-moz-placeholder{
      color: #333;
    }
    &:-ms-input-placeholder{
      color: #333;
    }

  }
}
.form-input{
  margin-top: 20px;
}
.custom-width{
  width: 100%;
}
</style>
